import { createReducer } from '@reduxjs/toolkit';

import {
  setActiveBookingStep,
  setBookingFormInitialValues,
  saveBookingFormSubmittedValues,
  saveExtraPicksSubmittedValues,
  recordOffCanvasOpened,
} from 'redux/actions/ui/jackson';

export const initialState = {
  initialValues: { values: {}, timestamp: Date.now() },
  bookingFormValues: {},
  extraPicksValues: {},
  offCanvasHasBeenOpened: false,
};

export default createReducer(initialState, {
  [setBookingFormInitialValues]: (state, action) => {
    state.initialValues = { values: action.payload, timestamp: Date.now() };
  },
  [saveBookingFormSubmittedValues]: (state, action) => {
    state.bookingFormValues = action.payload;
  },
  [saveExtraPicksSubmittedValues]: (state, action) => {
    state.extraPicksValues = action.payload;
  },
  [setActiveBookingStep]: (state, action) => {
    state.activeBookingStep = action.payload;
  },
  [recordOffCanvasOpened]: (state) => {
    state.offCanvasHasBeenOpened = true;
  },
});
